const cardTokens = ({ radii }) => ({
  sizesRadii: {
    small: radii.small,
    full: radii.small,
  },
});

export default cardTokens;
